import { render, staticRenderFns } from "./ServicoModule.vue?vue&type=template&id=1f562814"
import script from "./ServicoModule.vue?vue&type=script&lang=js"
export * from "./ServicoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports